// extracted by css-extract-rspack-plugin
export default {"historyHeader":"src-features-Integrations-features-ConnectedDeviceGroups-widgets-DeviceGroupWidget-assets-DeviceGroupWidget-module__historyHeader-ms5i6J","historyChevron":"src-features-Integrations-features-ConnectedDeviceGroups-widgets-DeviceGroupWidget-assets-DeviceGroupWidget-module__historyChevron-VFsxCf","historyChevronExpanded":"src-features-Integrations-features-ConnectedDeviceGroups-widgets-DeviceGroupWidget-assets-DeviceGroupWidget-module__historyChevronExpanded-IgTVc9"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"historyHeader\":\"src-features-Integrations-features-ConnectedDeviceGroups-widgets-DeviceGroupWidget-assets-DeviceGroupWidget-module__historyHeader-ms5i6J\",\"historyChevron\":\"src-features-Integrations-features-ConnectedDeviceGroups-widgets-DeviceGroupWidget-assets-DeviceGroupWidget-module__historyChevron-VFsxCf\",\"historyChevronExpanded\":\"src-features-Integrations-features-ConnectedDeviceGroups-widgets-DeviceGroupWidget-assets-DeviceGroupWidget-module__historyChevronExpanded-IgTVc9\"}";
        // 1791855167349
        var cssReload = require("../../../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  